import React from 'react';
import './style.css'


/*
Current Button Styles:
- back-button
- create-button
*/

const ContentHeadingButton = ({ buttonName, buttonStyleClass = '', handleContentHeadingButton}) => {
    return (
        <button className={`content-heading-button ${buttonStyleClass}`}  onClick={handleContentHeadingButton}>
            {buttonName}
        </button>
    );
};

export default ContentHeadingButton;
